import { render, staticRenderFns } from "./combo-button.vue?vue&type=template&id=3ffb112f&scoped=true&"
import script from "./combo-button.vue?vue&type=script&lang=js&"
export * from "./combo-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb112f",
  null
  
)

export default component.exports